export default {"src":"/_next/static/media/realEstateLogo1.d0c63a98.svg","height":44,"width":271,"blurWidth":0,"blurHeight":0};